import { FaceAmountComponent } from "@goodfill/domain-properties-components";
import { DecimalRangeColumnDefinition, decimalRangeFilter } from "../generic/DecimalRangeColumnDefinition";
import { DecimalRange } from "../../../filters/DecimalRangeFilter";
import { asAmount } from "@goodfill/domain-properties";

export const ORDER_BALANCE_AMOUNT_CRITERIA_KEY = "balanceAmount";

type CriteriaValue = DecimalRange;
type Criteria = { [ORDER_BALANCE_AMOUNT_CRITERIA_KEY]: CriteriaValue };
type FilterChangeFunction = (key: typeof ORDER_BALANCE_AMOUNT_CRITERIA_KEY, value: CriteriaValue) => void;

export const orderBalanceAmountFilter = <TItemKey extends string>(key: TItemKey) =>
  decimalRangeFilter(ORDER_BALANCE_AMOUNT_CRITERIA_KEY, key);

export const OrderBalanceAmountColumnDefinition = <TItemKey extends string,>(
  itemKey: TItemKey,
  criteria: Criteria,
  onFilterChange: FilterChangeFunction,
) =>
  DecimalRangeColumnDefinition({
    name: "Balance Amount",
    itemKey,
    criteriaKey: ORDER_BALANCE_AMOUNT_CRITERIA_KEY,
    criteria,
    onFilterChange,
    itemRenderer: (row) => <FaceAmountComponent value={asAmount(row[itemKey])} />,
    rangeFilterProps: { leftIcon: "$" },
  });
